// firebase-config.js
// This file configures Firebase for your training app

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// TODO: Replace with your Firebase project config from Firebase Console
// Get this from: Firebase Console → Project Settings → General → Your apps
const firebaseConfig = {
  apiKey: "AIzaSyA26VjGQFaxKGunOCAnBDBBAxWfffCUSMs",
  authDomain: "training-app-f469e.firebaseapp.com",
  projectId: "training-app-f469e",
  storageBucket: "training-app-f469e.firebasestorage.app",
  messagingSenderId: "504956450771",
  appId: "1:504956450771:web:11aa7c161447abdae12126"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore Database
export const db = getFirestore(app);

// Initialize Firebase Authentication
export const auth = getAuth(app);

export default app;
